import axios from 'axios';
import {AuthHeaders} from "../models/auth";
import { getAuthData, setAuthData } from '../utils/auth';
import AuthService from '../service/auth';
const config:any = {}
let authHeader: AuthHeaders | null = getAuthData();
if (authHeader) {
  config.headers = {}
  config.headers['access-token'] = authHeader['access-token'];
  config.headers['token-type'] = authHeader['token-type'];
  config.headers['client'] = authHeader.client;
  config.headers['expiry'] = authHeader.expiry;
  config.headers['uid'] = authHeader.uid;
}
export {config}
export const authService = axios.create({
  baseURL: `${process.env.REACT_APP_API_V1}`,...config,
})

authService.interceptors.response.use(
  config => {
    return config;
  },
  error => onError(error)
)

export const findawayService = axios.create({
  baseURL: `https://api.findawayworld.com/v4/`
})
export default function setup(history: any) {
  axios.defaults.baseURL = `${process.env.REACT_APP_API_V1}`;
  axios.interceptors.request.use(
    config => {
      let authHeader: AuthHeaders | null = getAuthData();
      if (authHeader) {
        config.headers['access-token'] = authHeader['access-token'];
        config.headers['token-type'] = authHeader['token-type'];
        config.headers['client'] = authHeader.client;
        config.headers['expiry'] = authHeader.expiry;
        config.headers['uid'] = authHeader.uid;
      }
      return config;
    }
  );
  axios.interceptors.response.use(
    config => {
      let headers = AuthService.getHeaders(config.headers)
      setAuthData(headers);
      return config;
    },
    error => onError(error, history)
  );
}
const onError = (error:any, history?: any) => {
  try {
    if (typeof error.response === 'undefined') {
      if (error.message === 'Network Error') {
        let customError = 'Service unavailable';
        throw new TypeError(customError);
      }
      // MEMO: in case of bad token
      // removeAuthData();
      // let customError = 'Invalid auth data';
      // history.push('/login')
      throw new TypeError('Service unavailable');
    } else {
      const {
        response: { status }
      } = error;
      let customError: any;
      switch (status) {
        case 400:
          customError = error.response.data.errors[0].detail;
          break;
        case 401:
          customError = 'You need sign in first'
          // history.push('/login')
          break;
        case 404:
          customError = error.response.data.errors[0].detail;
          history.push('/not_found')
          break;
        case 422:
          customError = error.response.data.errors[0].detail;
          break;
        default:
          customError = error.response.data.errors[0].detail;
          break;
      }
      throw new Error(customError);
    }
  } catch (e) {
    return Promise.reject(e);
  }
}
